export const en = {
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.copy': 'Copy',
  'common.copied': 'Copied!',
  'common.logout': 'Log out',
  'common.logoutTooltip': 'Log out',
  'common.refreshTooltip': 'Refresh',
  'common.backToOverview': 'Back to overview',
  'common.noDescription': 'No description',
  'common.retry': 'Try again',
  'common.yes': 'Yes',
  'common.no': 'No',
  'common.saveButton': 'Save',
  'common.savingButton': 'Saving...',
  'common.total': 'Total',
  'common.col.date': 'Date',
  'common.col.status': 'Status',

  'errors.genericError': 'Something went wrong.',
  'errors.defaultError': 'An error occurred',
  'errors.tryAgain': 'Something went wrong. Please try again.',
  'errors.signupFailed': 'Your organization could not be set up. Please sign in again and retry; contact support if this keeps happening.',
  'errors.joinFailed': 'Your access request could not be submitted. Please sign in again and retry.',
  'errors.requestFailed': 'Something went wrong while submitting the request.',
  'errors.api.badRequest': 'Invalid request. Please check the entered data.',
  'errors.api.unauthorized': 'Your session has expired. Please log in again.',
  'errors.api.forbidden': 'You do not have access to this feature.',
  'errors.api.notFound': 'The requested item was not found.',
  'errors.api.conflict': 'This action cannot be performed due to a conflict.',
  'errors.api.tooMany': 'Too many requests. Please try again later.',
  'errors.api.serverError': 'A server error occurred. Please try again later.',
  'errors.api.seatLimitReached': 'Seat limit reached for current plan.',
  'errors.api.onlyPendingCancel': 'Only pending requests can be cancelled.',
  'errors.api.timeout': 'The request took too long. Check your internet connection and try again.',

  'nav.servers': 'Servers',
  'nav.workflows': 'Workflows',
  'nav.myRequests': 'My requests',
  'nav.users': 'Users',
  'nav.usage': 'Usage',
  'nav.help': 'Help',

  'help.page.title': 'Getting started with Chat & MCP',
  'help.page.subtitle': 'Learn how to use AI chat and connect MCP servers.',
  'help.whatIsChat.title': 'What is Chat?',
  'help.whatIsChat.body':
    'Chat is a self-hosted AI assistant powered by open models. Your data stays within the platform — nothing is shared with external parties. All conversations are private and only visible to you.',
  'help.startChat.title': 'How do I open the chat?',
  'help.startChat.body':
    'Click the "Chat" button at the top of the Servers page. You will be logged in automatically with the same account you use for the portal.',
  'help.addMcpPortal.title': 'Step 1: Install an MCP in chat',
  'help.addMcpPortal.body':
    'Go to the server detail page of the MCP you want to use (click on the MCP card). Click the "Install in Chat" button next to the status chip. The button changes to "Installed" when done. This registers the MCP as a tool server in your chat environment.',
  'help.connectMcp.title': 'Step 2: Connect the MCP in chat',
  'help.connectMcp.body':
    'Open Chat and click your profile picture (bottom-left). Go to Settings > Integrations. Under "Manage Tool Servers", click the + button. Set the type to "MCP Streamable HTTP". Copy the MCP URL from the Connect tab on the server detail page. Leave Auth on "None" and click Save. The MCP tools are now available in your chats.',
  'help.functionCalling.title': 'Step 3: Enable Function Calling',
  'help.functionCalling.body':
    'Start a new chat. Click "Controls" (top-right, slider icon). Under "Advanced Params", change "Function Calling" from "Default" to "Native". This tells the AI to actually use the tools instead of just talking about them.',
  'help.testMcp.title': 'Step 4: Test the MCP',
  'help.testMcp.body':
    'In the message bar, click the connector icon (four-blocks icon) and toggle your MCP tools on. Then type a message like "Search for contacts named Jan". The AI will call the MCP tool and show real results from your system. Use a model that supports tool calling (e.g. Claude Sonnet).',
  'help.createProject.title': 'Using project instructions',
  'help.createProject.body':
    'Some MCP servers have project instructions (CLAUDE.md / GEMINI.md). Copy these into your AI project configuration to give the AI context about how to use the tools effectively.',

  'login.title': 'Smart extensions',
  'login.defaultSubtitle': 'Handy tools for your favorite AI chatclient.',
  'login.loginButton': 'Log in',
  'login.email': 'Email address',
  'login.emailPlaceholder': 'mail@domain.com',
  'login.continue': 'Continue',
  'login.selectOrganization': 'Select your organization',
  'login.noOrganization': 'No organization found for this email domain.',
  'login.back': 'Back',
  'login.loading': 'Looking up organizations...',
  'login.sessionExpired': 'Your session expired. Please sign in again.',
  'login.signInTitle': 'Sign in',
  'login.signInSubtitle': 'You\'ll be taken to your organization\'s sign-in screen.',
  'login.signIn': 'Continue to sign in',
  'signupProgress.title.creating': 'Setting up {org}',
  'signupProgress.title.signingIn': 'Signing you in',
  'signupProgress.subtitle': 'We\'re provisioning your workspace and refreshing your session. This only takes a moment.',
  'signupProgress.orgFallback': 'your workspace',
  'signupProgress.step.accountConnected': 'Account connected',
  'signupProgress.step.creatingOrg': 'Creating your organization',
  'signupProgress.step.signingIn': 'Signing you in',
  'signupProgress.footer': 'Don\'t close this tab — we\'ll redirect you automatically.',
  'login.joinTitle': 'Request access to {org}',
  'login.joinSubtitle': 'An organization already exists for this email domain. Sign in with your workspace account to request access — an administrator will review it.',
  'login.joinWithGoogle': 'Request access with Google',
  'login.joinWithMicrosoft': 'Request access with Microsoft',
  'memberPending.title.pending': 'Waiting for approval',
  'memberPending.body.pending': 'Your request to join {org} is waiting for an administrator to approve it. You\'ll get access as soon as they do.',
  'memberPending.title.rejected': 'Request declined',
  'memberPending.body.rejected': 'Your request to join {org} was declined. Contact your administrator if you think this was a mistake.',
  'memberPending.logout': 'Sign out',
  'pendingMembers.section.title': 'Pending member requests',
  'pendingMembers.section.empty': 'No pending requests right now.',
  'pendingMembers.approve': 'Approve',
  'pendingMembers.reject': 'Reject',
  'pendingMembers.source.kcAuto': 'Auto-joined via SSO',
  'login.notValid': 'The email address is not valid',
  'login.registerTitle': 'Register your organization',
  'login.registerSubtitle': 'No organization exists for this email yet. Give your organization a name, then continue with your workspace account.',
  'login.organizationName': 'Organization name',
  'login.organizationNamePlaceholder': 'e.g. Acme B.V.',
  'login.continueWith': 'Continue with',
  'login.or': 'or',
  'login.signInGoogle': 'Sign in with Google',
  'login.signInMicrosoft': 'Sign in with Microsoft',
  'login.signUpGoogle': 'Sign up with Google',
  'login.signUpMicrosoft': 'Sign up with Microsoft',
  'login.signUpEmail': 'Sign up with email',
  'login.registering': 'Creating your organization…',
  'login.registeredMessage': 'Your organization was created. Sign in again to activate your administrator role.',
  'login.signInAgain': 'Sign in again',
  'login.signupFailed': 'Signup failed. Please try again.',
  'login.idpUnavailable': 'Identity provider temporarily unavailable. Please try again.',
  'login.serverUnreachable': 'Could not reach the server. Check your connection and try again.',

  'servers.page.title': 'MCP Servers',
  'servers.page.subtitle': 'Discover available MCP servers and request access.',
  'servers.chat.button': 'Chat',
  'servers.chat.notConfiguredTooltip': 'Chat is not configured.',
  'servers.empty.adminTitle': 'No MCP servers found',
  'servers.empty.userTitle': 'No access to MCPs',
  'servers.empty.adminSubtitle': 'There are currently no MCP servers available for your organization.',
  'servers.empty.userSubtitle': 'You don\'t have access to MCPs yet. Ask your administrator to grant you access.',

  'servers.sort.activated': 'Activated first',
  'servers.sort.nameAsc': 'Name A–Z',
  'servers.sort.nameDesc': 'Name Z–A',
  'servers.sort.newest': 'Newest first',
  'servers.sort.oldest': 'Oldest first',
  'servers.filter.allApps': 'All applications',
  'servers.filter.selected': 'selected',

  'serverCard.activateButton': 'Activate MCP',
  'serverCard.instantAddButton': 'Add instantly',
  'serverCard.slotLimitTooltip': 'Plan limit reached (upgrade your plan)',

  'serverDetail.backButton': 'All servers',
  'serverDetail.notFound.title': 'MCP server not found',
  'serverDetail.tools.defaultTag': 'Other',
  'serverDetail.header.activateMcp': 'Activate MCP',
  'serverDetail.header.requestAccess': 'Request access',
  'serverDetail.blocked': 'This MCP is temporarily disabled until {until}.',
  'serverDetail.tabs.about': 'About',
  'serverDetail.tabs.connect': 'Connect',
  'serverDetail.tabs.tools': 'Tools ({count})',
  'serverDetail.tabs.skills': 'Skills ({count})',
  'serverDetail.tabs.users': 'Users',
  'serverDetail.tabs.logs': 'Logs',
  'serverDetail.about.empty': 'No detailed description available.',
  'serverDetail.skills.empty': 'No skills available.',
  'serverDetail.copySkill': 'Copy skill',
  'serverDetail.connect.noAccess.title': 'No access',
  'serverDetail.connect.noAccess.body': 'Request access first to view connection instructions.',
  'serverDetail.connect.inactiveAlert': 'Authentication only works when this MCP is activated for your organization.',
  'serverDetail.connect.step.addServer': 'Add MCP Server',
  'serverDetail.connect.step.authenticate': 'Authenticate',
  'serverDetail.connect.step.createProject': 'Create project',
  'serverDetail.connect.step.addCustomInstructions': 'Add custom instructions',
  'serverDetail.connect.step.runCommand': 'Run the following command in your terminal:',
  'serverDetail.connect.step.addSkills': 'Add skills',
  'serverDetail.connect.claude.desktop.step1.hint': 'Open Claude Desktop or claude.ai and go to Settings \u2192 Connectors \u2192 Add custom connector. Enter the URL below and click Add.',
  'serverDetail.connect.claude.desktop.step2.hint': 'After adding, the MCP server will appear in your connector list. Click on it to authenticate with your credentials.',
  'serverDetail.connect.claude.desktop.step3.hint': 'Create a new Project via the left menu in Claude and add the MCP server as a connector in the project settings.',
  'serverDetail.connect.claude.desktop.step4.hint': 'Add the following instructions to the Project instructions field of your project for the best results.',
  'serverDetail.connect.claude.code.step1.altHint': 'Or add to',
  'serverDetail.connect.claude.code.step2.hint': 'On first use, Claude Code will automatically open a browser window for you to log in. After authentication, the MCP server is ready to use.',
  'serverDetail.connect.claude.code.step3.title': 'Project instructions (CLAUDE.md)',
  'serverDetail.connect.claude.code.step3.hint': 'Create a CLAUDE.md file in your project root with the content below.',
  'serverDetail.connect.claude.code.step4.hint': 'Copy the skills below to the .claude/skills/ directory in your project.',
  'serverDetail.connect.copilot.app.step1.hint': 'Open Microsoft 365 Copilot Studio and navigate to your agent. Go to Actions \u2192 Add action \u2192 MCP Server. Enter the URL below.',
  'serverDetail.connect.copilot.app.step2.hint': 'After adding the MCP server, Copilot will prompt you to authenticate. Log in with your credentials to authorize access.',
  'serverDetail.connect.copilot.app.step3.hint': 'Add the content below as instructions to your Copilot agent to guide how it uses this MCP server.',
  'serverDetail.connect.copilot.app.step4.hint': 'Add the following instructions to your Copilot agent for the best results.',
  'serverDetail.connect.copilot.vscode.step1.hint': 'Open VS Code and go to Settings (Ctrl+,) \u2192 search "mcp". Click "Edit in settings.json" and add the configuration below under "github.copilot.chat.mcp.servers":',
  'serverDetail.connect.copilot.vscode.step2.hint': 'When Copilot uses the MCP server for the first time, a browser window will open for authentication. Log in with your credentials.',
  'serverDetail.connect.copilot.vscode.step3.hint': 'Create a .github/copilot-instructions.md file in your project root with the content below.',
  'serverDetail.connect.copilot.vscode.step4.hint': 'Add the following instructions to your .github/copilot-instructions.md file for the best results.',
  'serverDetail.connect.chatgpt.step1.hint': 'Open ChatGPT and go to Settings \u2192 Connectors \u2192 Advanced. Enter the URL below and click Save.',
  'serverDetail.connect.chatgpt.step2.hint': 'After creating, you will be automatically redirected to authenticate. Log in with your credentials.',
  'serverDetail.connect.chatgpt.step3.hint': 'Create a new Project in the ChatGPT sidebar and add the MCP server as a connector.',
  'serverDetail.connect.chatgpt.step4.hint': 'Add the following instructions to your Project instructions for the best results.',
  'serverDetail.connect.gemini.app.step1.title': 'Create Gem',
  'serverDetail.connect.gemini.app.step1.hint': 'Open Gemini and go to Gem manager \u2192 New Gem. Give it a name and description.',
  'serverDetail.connect.gemini.app.step2.title': 'Gem instructions',
  'serverDetail.connect.gemini.app.step2.hint': 'Paste the instructions below into the Instructions field of your Gem.',
  'serverDetail.connect.gemini.app.step3.hint': 'Add the following instructions to the Instructions field of your Gem.',
  'serverDetail.connect.gemini.cli.step1.altHint': 'Or add to .gemini/settings.json:',
  'serverDetail.connect.gemini.cli.step2.hint': 'On first use, Gemini CLI will automatically open a browser window for you to log in. After authentication, the MCP server is ready to use.',
  'serverDetail.connect.gemini.cli.step3.title': 'Project instructions (GEMINI.md)',
  'serverDetail.connect.gemini.cli.step3.hint': 'Create a GEMINI.md file in your project root with the content below.',
  'serverDetail.connect.gemini.cli.step4.hint': 'Copy the skills below to the .gemini/skills/ directory in your project.',
  'serverDetail.environment': 'Environment',
  'serverDetail.environments': 'Environments',
  'serverDetail.selectEnvironment': 'Select environment',

  'serverDetail.connected': 'Connected',

  'serverDetail.remove': 'Remove MCP',
  'serverDetail.removing': 'Removing...',
  'serverDetail.removeConfirm': 'Are you sure you want to remove this MCP? All user access and chat installations will be removed.',

  'myRequests.page.title': 'My requests',
  'myRequests.page.subtitle': 'Overview of your requests.',
  'myRequests.empty.title': 'No requests',
  'myRequests.empty.subtitle': 'You haven\'t submitted any requests yet.',
  'myRequests.platformRequests.sectionTitle': 'Platform requests',
  'myRequests.accessRequests.sectionTitle': 'Access requests',
  'myRequests.platformRequests.col.tier': 'Tier',
  'myRequests.col.status': 'Status',
  'myRequests.col.date': 'Date',
  'myRequests.col.note': 'Note',
  'myRequests.col.actions': '',
  'myRequests.cancel': 'Cancel',
  'myRequests.cancelConfirm': 'Are you sure you want to cancel this request?',
  'myRequests.accessRequests.col.server': 'MCP Server',
  'myRequests.accessRequests.col.type': 'Type',
  'myRequests.requestType.organization': 'Organization',
  'myRequests.requestType.user': 'User',

  'seats.page.title': 'User management',
  'seats.page.subtitle': 'seats in use',
  'seats.addButton': 'Assign seat',
  'seats.col.email': 'Email',
  'seats.col.assignedBy': 'Assigned by',
  'seats.col.chat': 'Chat',
  'seats.chat.disable': 'Disable chat',
  'seats.chat.enable': 'Enable chat',
  'seats.deleteTooltip': 'Remove seat',
  'seats.deleteConfirm': 'Are you sure you want to remove this seat?',
  'seats.table.empty': 'No seats assigned yet.',
  'seats.accessDenied.title': 'No access',
  'seats.accessDenied.body': 'User management is only available for administrators.',
  'seats.assignDialog.title': 'Assign seat',
  'seats.assignDialog.searchLabel': 'Search user',
  'seats.assignDialog.searchPlaceholder': 'Name or email address',
  'seats.assignDialog.searchMinChars': 'Type at least 2 characters to search',
  'seats.assignDialog.noUsers': 'No users found',
  'seats.assignDialog.assignButton': 'Assign',
  'seats.assignDialog.assigningButton': 'Assigning...',

  'usage.page.title': 'Usage',
  'usage.page.subtitle': 'Current month \u2014 costs and usage for your organization.',
  'usage.page.periodBanner': 'This month so far \u00b7 {period}',
  'usage.historyButton': 'Previous months',
  'usage.limitsButton': 'Limits',
  'usage.dailyTable.title': 'Daily overview',
  'usage.col.mcp': 'MCP',
  'usage.col.workflow': 'Workflows',
  'usage.col.chat': 'Chat',
  'usage.col.total': 'Total',
  'usage.dailyTable.empty': 'No data this month.',
  'usage.costSummary.title': 'Monthly costs',
  'usage.costSummary.subtitle': 'Costs charged this month',
  'usage.costSummary.fixedCosts': 'Fixed costs',
  'usage.costSummary.platformCosts': 'MCP usage',
  'usage.costSummary.workflowCosts': 'Workflow executions',
  'usage.costSummary.executionsSuffix': '{n} executions',
  'usage.costSummary.chatCosts': 'AI chat usage',
  'usage.fixedCosts.title': 'Monthly fixed costs',
  'usage.fixedCosts.seats': 'Seats: {count} \u00d7 {price}',
  'usage.fixedCosts.mcps': 'MCPs: {count} \u00d7 {price}',
  'usage.fixedCosts.workflows': 'Workflows: {count} \u00d7 {price}',
  'usage.fixedCosts.subtotal': 'Subtotal',
  'usage.percentOfLimit': '{pct}% of limit ({budget})',
  'usage.breakdown.title': 'Costs per source',
  'usage.breakdown.mcpTitle': 'MCP servers',
  'usage.breakdown.workflowTitle': 'Workflows',
  'usage.breakdown.showMore': 'Show {count} more',
  'usage.breakdown.showLess': 'Show less',
  'usage.breakdown.empty': 'No costs',
  'usage.empty': 'No usage data yet. Use MCP servers, workflows, or chat to generate usage.',
  'usage.accessDenied.title': 'No access',
  'usage.accessDenied.body': 'Usage is only available for administrators.',
  'usage.budgetDialog.title': 'Set cost limits',
  'usage.budgetDialog.platformLimit': 'MCP limit (EUR/month)',
  'usage.budgetDialog.workflowLimit': 'Workflow limit (EUR/month)',
  'usage.budgetDialog.aiHourlyLimit': 'AI hourly limit for workflows (EUR/hour)',
  'usage.budgetDialog.aiHourlyLimitHint':
    'Hard stop on automated AI calls inside workflows. Exceeding it stops the workflow.',
  'usage.budgetDialog.aiHourlyLimitCeilingHint':
    'Platform ceiling: {ceiling}/hour. Contact the platform admin to raise it.',
  'usage.budgetDialog.noLimit': 'No limit',
  'usage.budgetDialog.hint': 'Set to 0 or leave empty for no limit.',
  'usage.historyDialog.title': 'Previous months',
  'usage.historyDialog.empty': 'No historical data available.',
  'usage.historyDialog.col.month': 'Month',
  'usage.historyDialog.col.seats': 'Seats',
  'usage.historyDialog.col.mcps': 'MCPs',
  'usage.historyDialog.col.fixedCosts': 'Fixed costs',
  'usage.historyDialog.col.platform': 'MCP',
  'usage.historyDialog.col.workflows': 'Workflows',
  'usage.historyDialog.col.chat': 'Chat',
  'usage.historyDialog.col.total': 'Total',

  // AI quota widget
  'usage.aiQuota.title': 'Hourly AI workflow limit',
  'usage.aiQuota.subtitle': 'Hard stop on automated AI calls inside workflows',
  'usage.aiQuota.spent': 'Spent this hour',
  'usage.aiQuota.quota': 'Hourly limit',
  'usage.aiQuota.unmetered': 'Unlimited — no hourly cap active for this organization.',
  'usage.aiQuota.unavailable': 'Live AI budget is temporarily unavailable.',
  'usage.aiQuota.helper': 'Reduces gradually as older calls fall out of the 1-hour window.',
  'usage.aiQuota.percentOfQuota': '{pct}% of hourly limit',
  'usage.breakdown.workflowLabelPrefix': 'Workflow:',
  'usage.breakdown.subtitle': 'Variable costs split by source',

  'requestAccess.title': 'Activate MCP for my organization',
  'requestAccess.success': 'Your request for {serverName} has been submitted. An administrator will review it.',
  'requestAccess.description': 'This MCP is not yet activated for your organization. Specify the environment you want to activate the MCP for.',
  'requestAccess.envUrlLabel': 'Environment URL',
  'requestAccess.envUrlPlaceholder': 'https://api.myenvironment.com',
  'requestAccess.envUrlHelper': 'The API URL of the environment you want access for',
  'requestAccess.messageLabel': 'Message (optional)',
  'requestAccess.messagePlaceholder': 'Why do you need access?',
  'requestAccess.urlError': 'Enter a valid HTTPS URL (e.g. https://api.example.com)',
  'requestAccess.environmentLabel': 'Environment',
  'requestAccess.submitButton': 'Submit request',
  'requestAccess.submittingButton': 'Submitting...',

  'toolsTable.col.name': 'Name',
  'toolsTable.col.type': 'Type',
  'toolsTable.col.required': 'Required',
  'toolsTable.col.description': 'Description',
  'toolsTable.empty': 'No tools available.',

  'logsTab.title': 'Recent logs',
  'logsTab.empty': 'No logs available for this server.',
  'logsTab.col.tool': 'Tool',
  'logsTab.col.user': 'User',
  'logsTab.col.responseTime': 'Response time',
  'logsTab.status.success': 'Success',
  'logsTab.status.error': 'Error',

  'usersTab.title': 'User management',
  'usersTab.empty': "Add a user in 'Users' to give a user access to this MCP.",
  'usersTab.col.user': 'User',
  'usersTab.col.access': 'Access',
  'usersTab.revokeButton': 'Revoke',
  'usersTab.activateButton': 'Activate',

  'upgradeBanner.text': 'Upgrade to team for more seats and higher limits, or to enterprise for unlimited seats, no limits, and our own EU hosted models.',
  'upgradeBanner.textTeam': 'Need more seats or MCPs? Upgrade to enterprise for unlimited access, EU hosted chat models and everything {title} has to offer.',
  'upgradeBanner.pending': 'Request is being processed',
  'upgradeBanner.upgradeTeamButton': 'Upgrade to team',
  'upgradeBanner.upgradeEnterpriseButton': 'Activate enterprise',

  'pricing.page.title': 'Choose a plan',
  'pricing.page.subtitle': 'Activate the right plan for your organization to get started with MCP Hub.',
  'pricing.adminOnly': 'Only administrators can request a plan.',
  'pricing.pendingRequest': 'A request is already being processed. You will receive a notification once it has been reviewed.',
  'pricing.currentPlan.chip': 'Current plan',
  'pricing.button.current': 'Current plan',
  'pricing.button.requesting': 'Requesting...',
  'pricing.button.request': 'Request',
  'pricing.snackbar.submitted': 'Request submitted \u2014 you will receive a notification once it has been processed.',
  'pricing.tier.free.label': 'Free',
  'pricing.tier.free.tagline': 'Get to know the MCP Platform',
  'pricing.tier.free.feature.mcps': '1 MCP active',
  'pricing.tier.free.feature.seats': '1 seat (yourself only)',
  'pricing.tier.free.feature.calls': 'Max 100 calls per day',
  'pricing.tier.team.label': 'Team',
  'pricing.tier.team.tagline': 'For teams',
  'pricing.tier.team.feature.mcps': '3 MCPs active',
  'pricing.tier.team.feature.seats': '6 seats',
  'pricing.tier.team.feature.calls': 'Max 1,000 calls per day',
  'pricing.tier.enterprise.label': 'Enterprise',
  'pricing.tier.enterprise.tagline': 'Maximum flexibility for large organizations',
  'pricing.tier.enterprise.feature.mcps': 'Unlimited MCPs',
  'pricing.tier.enterprise.feature.seats': 'Unlimited seats',
  'pricing.tier.enterprise.feature.calls': 'Unlimited calls',
  'pricing.tier.enterprise.feature.chat': 'European hosted models',
  'pricing.tier.enterprise.feature.governance': 'Guardrails & AI Governance',

  'pending.title': 'Request being processed',
  'pending.body': 'Your request has been received. We will contact you as soon as possible to activate your access.',

  'registration.welcome': 'Welcome to {title}',
  'registration.heading': 'How do you want to use {title}?',
  'registration.subheading': 'Choose the option that best fits your situation. You can always upgrade later.',
  'registration.tier.free.tagline': 'Explore the possibilities',
  'registration.tier.team.tagline': 'Implement with a team',
  'registration.tier.enterprise.tagline': 'Fully operational',
  'registration.messagePlaceholder': 'Optional: Tell us about your use case and expectations...',
  'registration.submitButton': 'Submit request',
  'registration.submitButtonFree': 'Try now',

  'authGuard.accessDenied.title': 'No access',
  'authGuard.accessDenied.body': 'You don\'t have access to MCP Hub. Contact your administrator to get a seat.',
  'authGuard.tryAgain': 'Try again',
  'authGuard.joinPrompt.title': 'Join {org}',
  'authGuard.joinPrompt.body': 'An organization for your email domain already exists. Request access and an administrator will review it.',
  'authGuard.joinPrompt.requestAccess': 'Request access',
  'authGuard.joinPrompt.cancel': 'Not now',
  'authGuard.orgSignupPrompt.title': 'Set up your organization',
  'authGuard.orgSignupPrompt.body': 'No organization exists for your account yet. Give your organization a name to finish setting up your workspace.',
  'authGuard.orgSignupPrompt.submit': 'Create organization',
  'authGuard.orgSignupPrompt.cancel': 'Sign out',

  'errorBoundary.title': 'Something went wrong',
  'errorBoundary.body': 'Try refreshing the page. If the problem persists, contact support.',
  'errorBoundary.reloadButton': 'Refresh page',

  'accessStatus.full_access': 'Connected',
  'accessStatus.org_linked_no_user': 'No access',
  'accessStatus.not_linked': 'Not activated',
  'accessStatus.request_pending': 'Request sent',
  'accessStatus.instant_available': 'Instantly available',
  'accessStatus.active': 'Active',

  'requestStatus.pending': 'Pending',
  'requestStatus.approved': 'Approved',
  'requestStatus.denied': 'Denied',
  'requestStatus.cancelled': 'Cancelled',

  'tierLabel.free': 'Free',
  'tierLabel.team': 'Team',
  'tierLabel.enterprise': 'Enterprise',

  'plan.page.title': 'My plan',
  'plan.page.subtitle': 'Overview of your current plan and usage.',
  'plan.accessDenied.title': 'No access',
  'plan.accessDenied.body': 'Plan management is only available for administrators.',
  'plan.activateCta.title': 'Activate a plan now',
  'plan.activateCta.body': 'You don\'t have an active platform yet. Activate a plan to start using MCPs.',
  'plan.activateCta.button': 'Activate plan',
  'plan.organization': 'Organization',
  'plan.stat.mcps': 'MCPs active',
  'plan.stat.seats': 'Seats in use',
  'plan.changePlanButton': 'Change plan',
  'plan.tier.none': 'No plan',
  'plan.tier.free': 'Free',
  'plan.tier.team': 'Team',
  'plan.tier.enterprise': 'Enterprise',

  // Tier features (constants)
  'tier.free.label': 'Test setup',
  'tier.free.feature.seats': '1 seat',
  'tier.free.feature.mcps': '1 MCP active',
  'tier.free.feature.requests': 'Limited daily requests',
  'tier.team.label': 'Pilot implementation',
  'tier.team.feature.seats': '6 seats',
  'tier.team.feature.mcps': '3 MCPs active',
  'tier.team.feature.requests': 'More requests per day',
  'tier.enterprise.label': 'Production',
  'tier.enterprise.feature.seats': 'Unlimited seats',
  'tier.enterprise.feature.mcps': 'All MCPs',
  'tier.enterprise.feature.chat': 'Chat included',

  'workflow.title': 'Workflows',
  'workflow.subtitle': 'Automated MCP tool chains for your organization',
  'workflow.configure': 'Configure',
  'workflow.instantAdd': 'Instant add',
  'workflow.requestAccess': 'Request access',
  'workflow.awaitingApproval': 'Awaiting approval',
  'workflow.empty': 'No workflows available yet',
  'workflow.upgradeRequired': 'Upgrade your plan to use workflows',
  'workflow.filter.allTriggers': 'All triggers',
  'workflow.trigger.manual': 'Manual',
  'workflow.trigger.cron': 'Scheduled',
  'workflow.trigger.mcp': 'MCP',
  'workflow.requestDialog.description': 'Specify the MCP server configuration for each server used in this workflow.',
  'workflow.requestDialog.mcpConfig': 'MCP Server Configuration',
  'workflow.requestDialog.variables': 'Variables',
  'workflow.requestDialog.variablesHelper': 'Values your organisation supplies for the variables this workflow references. Leave empty to fill in later from the link settings.',
  'workflow.requestDialog.seat': 'User',
  'workflow.requestDialog.environment': 'Environment',
  'workflow.requestDialog.selectEnvironment': 'Select an environment',
  'workflow.requestDialog.baseUrl': 'Target URL',
  'workflow.requestDialog.message': 'Message (optional)',
  'workflow.requestDialog.messagePlaceholder': 'Additional context for the admin...',
  'workflow.requestDialog.cancel': 'Cancel',
  'workflow.requestDialog.submit': 'Submit request',
  'workflow.requestDialog.attachmentLabel': 'Data attachment',
  'workflow.requestDialog.attachmentChoose': 'Choose file',
  'workflow.requestDialog.attachmentNone': 'No file chosen',
  'workflow.requestDialog.attachmentRequired': 'This workflow requires a file attachment.',
  'workflow.requestDialog.attachmentHelp': 'This file is the data source for the workflow. Max 10 MB.',
  'workflow.tabs.flow': 'Flow',
  'workflow.tabs.connect': 'Connect',
  'workflow.connect.urlLabel': 'MCP server URL',
  'workflow.connect.urlHelp': 'Add this URL as an MCP server in Claude Desktop. Authentication runs through the SecureAccess login.',
  'workflow.connect.heroEyebrow': 'Connect via MCP',
  'workflow.connect.heroTitle': 'Use %{workflow} from your AI assistant',
  // eslint-disable-next-line max-len
  'workflow.connect.heroBody': 'Add the URL below as an MCP server in Claude. Sign in once with your SecureAccess account; the workflow then appears as a tool you can call from any conversation.',
  'workflow.connect.step.add': 'Add as MCP server',
  'workflow.connect.step.addHint': 'Edit your Claude Desktop config and restart Claude Desktop.',
  'workflow.connect.inactiveAlert': 'Authentication only works once this workflow is activated for your organization.',
  'workflow.connect.step.login': 'Sign in to SecureAccess',
  // eslint-disable-next-line max-len
  'workflow.connect.step.loginHint': 'On first use Claude opens a browser window for the SecureAccess OAuth flow. Approve and the connection is bound to your account.',
  'workflow.connect.step.prompt': 'Try it',
  // eslint-disable-next-line max-len
  'workflow.connect.step.promptHint': 'In any new chat the workflow shows up as a tool. Ask Claude to use it with a natural-language instruction.',
  'workflow.connect.desktop.step1Title': 'Add to claude_desktop_config.json',
  // eslint-disable-next-line max-len
  'workflow.connect.desktop.step1Hint': 'Open Claude Desktop settings → Developer → Edit config, paste the snippet below, save and restart Claude Desktop.',
  'workflow.connect.code.step1Title': 'Run claude mcp add',
  'workflow.connect.code.step1Hint': 'In a terminal, run the command below. Claude Code registers the workflow for the current project.',
  'workflow.connect.web.step1Title': 'Add a custom connector on claude.ai',
  // eslint-disable-next-line max-len
  'workflow.connect.web.step1Hint': 'Open the Connectors page in your Claude.ai settings, choose Add custom connector and paste the URL.',
  'workflow.connect.noAccess.title': 'No access yet',
  'workflow.connect.noAccess.body': 'Request access to this workflow first.',
  'workflow.loadError': 'Failed to load workflows',
  'workflow.actionError': 'Action failed. Please try again.',
  'workflow.ai.button': 'Generate with AI',
  'workflow.ai.title': 'AI workflow generator',
  'workflow.ai.intro':
    'Describe the process the workflow should perform. Include how the workflow should start, the steps in between, and the expected result. Our AI will analyse your description; once it has enough information you can submit the workflow for approval.',
  'workflow.ai.guide.title': 'How a workflow is built',
  'workflow.ai.guide.subtitle': 'Click for a short walkthrough of the building blocks.',
  'workflow.ai.guide.triggerTitle': 'Trigger',
  'workflow.ai.guide.triggerBody':
    'Every workflow starts with a trigger — a manual button click, a schedule (e.g. every weekday at 9:00), or an incoming webhook from another system.',
  'workflow.ai.guide.toolTitle': 'Connect to a system',
  'workflow.ai.guide.toolBody':
    'Tool steps reach out to one of the connected MCP servers (Topdesk, Slack, the case system, …) to fetch or change data. Mention the system and what it should fetch or do.',
  'workflow.ai.guide.aiTitle': 'Let AI think',
  'workflow.ai.guide.aiBody':
    'AI steps can summarise, translate, classify, or extract specific fields from previous output. Be specific about the input and the desired result.',
  'workflow.ai.guide.logicTitle': 'Logic & loops',
  'workflow.ai.guide.logicBody':
    'Use conditions ("only when status = open") and loops ("for each ticket, …") to control how the workflow proceeds through your data.',
  'workflow.ai.guide.outputTitle': 'Final output',
  'workflow.ai.guide.outputBody':
    'Tell the admin where the result should go: a Slack channel, an email, a notification, a new case, or a visualisation in the dashboard.',
  'workflow.ai.guide.exampleTitle': 'Example',
  'workflow.ai.guide.exampleBody':
    '"Fetch open items from system A, have AI summarise them, and post the result in system B."',
  'workflow.ai.descriptionLabel': 'Describe the workflow',
  'workflow.ai.descriptionPlaceholder':
    'Every weekday at 9:00 fetch the open Topdesk tickets, summarise them with an LLM, and post the summary in #service-desk on Slack.',
  'workflow.ai.submit': 'Continue',
  'workflow.ai.analyzing': 'Analysing your description…',
  'workflow.ai.needsMoreInfo': 'I need a bit more information',
  'workflow.ai.answerLabel': 'Add the missing details',
  'workflow.ai.answerPlaceholder': 'Provide the missing information…',
  'workflow.ai.summaryTitle': 'Here is what will be built',
  'workflow.ai.summaryHintRequest':
    'An admin will review this description and build the workflow once approved.',
  'workflow.ai.requestButton': 'Submit request',
  'workflow.ai.edit': 'Adjust description',
  'workflow.ai.requesting': 'Submitting your request…',
  'workflow.ai.requestedTitle': 'Request submitted',
  'workflow.ai.requestedMessage':
    'An admin has been notified. You will hear back once the workflow is built.',
  'workflow.ai.close': 'Close',
  'workflow.ai.errorTitle': 'Something went wrong',
  'workflow.ai.errorBody': 'The assistant could not process this request.',
  'workflow.ai.retry': 'Try again',
  'myRequests.aiRequests.sectionTitle': 'AI workflow requests',
  'myRequests.aiRequests.col.prompt': 'Description',
  'workflow.nodeDetail.title': 'Node Configuration',
  'workflow.nodeDetail.triggerType': 'Trigger type',
  'workflow.nodeDetail.cronExpression': 'Schedule',
  'workflow.nodeDetail.webhookPath': 'Webhook path',
  'workflow.nodeDetail.server': 'MCP Server',
  'workflow.nodeDetail.tool': 'Tool',
  'workflow.nodeDetail.parameters': 'Parameters',
  'workflow.nodeDetail.expression': 'Expression',
  'workflow.nodeDetail.arrayExpression': 'Array expression',
  'workflow.nodeDetail.itemVariable': 'Item variable',
  'workflow.nodeDetail.strategy': 'Strategy',
  'workflow.nodeDetail.mappings': 'Field mappings',
  'workflow.nodeDetail.triggerButton': 'Trigger workflow',
  'workflow.nodeDetail.triggerSuccess': 'Workflow triggered successfully',
  'workflow.nodeDetail.triggerError': 'Failed to trigger workflow',
  'workflow.nodeDetail.type': 'Type',

  'workflow.backButton': 'Back to workflows',
  'workflow.remove': 'Remove workflow',
  'workflow.removing': 'Removing...',
  'workflow.removeConfirm': 'Are you sure you want to remove this workflow? All access will be revoked and all execution records (runs and usage logs) will be permanently deleted.',
  'workflow.trigger': 'Execute',
  'workflow.triggerSuccess': 'Workflow started',
  'workflow.variables.missingTitle': 'Variables missing',
  'workflow.variables.missingBody': 'This workflow references variables that have no value for your organisation. Ask an administrator to fill them in, or set them via the link configuration before the next run.',
  'workflow.tabs.about': 'About',
  'workflow.tabs.tools': 'Tools',
  'workflow.badge.mcp': 'MCP',
  'workflow.badge.ai': 'AI',
  'workflow.badge.mcpTooltip': 'Exposed as an MCP tool for AI clients',
  'workflow.badge.aiTooltip': 'Contains an AI step',
  'workflow.tabs.diagram': 'Diagram',
  'workflow.tabs.executions': 'Executions',
  'workflow.about.empty': 'No description available',
  'workflow.executions.empty': 'No executions yet',
  'workflow.executions.status': 'Status',
  'workflow.executions.trigger': 'Trigger',
  'workflow.executions.startedBy': 'Started by',
  'workflow.executions.started': 'Started',
  'workflow.executions.duration': 'Duration',
  'workflow.executionStatus.pending': 'Pending',
  'workflow.executionStatus.running': 'Running',
  'workflow.executionStatus.completed': 'Completed',
  'workflow.executionStatus.failed': 'Failed',
  'workflow.triggerType.manual': 'Manual',
  'workflow.triggerType.cron': 'Scheduled',
  'workflow.triggerType.webhook': 'Webhook',
  'workflow.stats.nodes': '{count} nodes',
  'workflow.stats.trigger': 'Trigger: {type}',
  'workflow.notFound.title': 'Workflow not found',

  'workflow.tabs.users': 'Users',

  'workflow.tabs.webhook': 'Webhook',
  'workflow.webhook.title': 'Webhook integration',
  'workflow.webhook.description': 'Trigger this workflow from an external system by sending a POST request to the URL below.',
  'workflow.webhook.url': 'Webhook URL',
  'workflow.webhook.auth': 'Authentication',
  'workflow.webhook.authDescription': 'Include a valid Bearer token in the Authorization header.',
  'workflow.webhook.parameters': 'Parameters',
  'workflow.webhook.parametersDescription': 'Send parameters as JSON in the request body under the "trigger_input" key.',
  'workflow.webhook.name': 'Name',
  'workflow.webhook.type': 'Type',
  'workflow.webhook.required': 'Required',
  'workflow.webhook.optional': 'Optional',
  'workflow.webhook.descriptionCol': 'Description',
  'workflow.webhook.example': 'Example request',
  'workflow.webhook.noLink': 'Webhook is available after the workflow is linked to your organization.',

  'workflow.visualizations.title': 'Visualizations',

  'visualization.noData': 'No data available. Run the workflow first.',
  'visualization.accessDenied.title': 'No access',
  'visualization.accessDenied.body': 'You don\'t have access to this visualization. Contact your administrator.',
  'visualization.notFound.title': 'Not found',
  'visualization.notFound.body': 'This visualization could not be found.',
} as const;

export type TranslationKey = keyof typeof en;
